import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
} from "@mui/material";
import ListHeader from "./ListHeader";
import {
  mongoTimeStampToString,
} from "../../utils/orders";
import { LOGS_ACTION_SPANISH } from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import ListPagination from "./ListPagination";
import { IFailedOrderLog } from "../../interfaces/order";
import { IPaginationParams } from "../../interfaces/table";

interface IListFailedOrderLogsProps {
  failedOrderLogs: IFailedOrderLog[];
  pagination: IPaginationParams;
  handlePageChange: (_newPage: number) => void;
}

const COLUMNS = [
  {
    label: "Fecha y hora",
  },
  {
    label: "ID externo",
  },
  {
    label: "Acción",
  },
  {
    label: "Servicio",
  },
  {
    label: "Acciones",
  },
];

const ListFailedOrderLogs = ({ failedOrderLogs, pagination , handlePageChange}: IListFailedOrderLogsProps) => {
  const navigate = useNavigate();

  return (
    <TableContainer component={Paper} className="m-t-40 br-20 bg-light" sx={{ maxWidth: "60%" }}>
      <Table>
        <ListHeader columns={COLUMNS} />
        <TableBody>
          {failedOrderLogs.map(
            ({ _id, external_id, action, service, createdAt }: any) => (
              <TableRow key={_id}>
                <TableCell>{mongoTimeStampToString(createdAt)}</TableCell>
                <TableCell>{external_id}</TableCell>
                <TableCell>{LOGS_ACTION_SPANISH[action]}</TableCell>
                <TableCell>
                  {service ? service.toUpperCase() : "-"}
                </TableCell>
                <TableCell>
                  <Tooltip title="Ver">
                    <IconButton onClick={() => navigate(`log/${_id}`)}>
                      <i className="material-symbols-rounded">visibility</i>
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </Table>
      <ListPagination
        total={pagination.count}
        page={pagination.page}
        onChangePage={handlePageChange}
      />
    </TableContainer>
  );
};

export default ListFailedOrderLogs;
